module.exports = __webpack_public_path__ + "media/we_make_pans.a401848e.mp4";